'use client';

import { createContext, useContext } from 'react';

const PrefilledNearPointCtx = createContext(false);
export const PrefilledNearPointProvider = PrefilledNearPointCtx.Provider;
export function useHasPrefilledNearPoint(): boolean {
    return useContext(PrefilledNearPointCtx);
}

export function isNearPointActive(value: {
    nearCleared?: boolean | null;
    nearLat?: number | null;
    nearLng?: number | null;
}): boolean {
    return !value.nearCleared && value.nearLat != null && value.nearLng != null;
}

/** Update payload that drops the whole distance-search triple. Label,
 * coordinates and radius are one filter: leaving any of them behind either keeps
 * the search pinned to a place the UI no longer shows, or shows a place that no
 * longer filters (FUN-4743). `extra` lets the section-level reset clear its own
 * fields in the same update without re-stating the triple.
 *
 * Lives outside `ActivityFilterDrawer` so it can be unit-tested without pulling
 * the drawer's whole client-app import graph (env, trpc, posthog) into vitest. */
export function NEAR_POINT_CLEARED<T extends object>(args: {
    hasPrefilledNearPoint: boolean;
    extra?: T | null;
}) {
    return {
        nearLabel: null,
        nearLat: null,
        nearLng: null,
        radius: null,
        nearCleared: args.hasPrefilledNearPoint ? true : null,
        ...args.extra,
    };
}

export function NEAR_POINT_PICKED(point: {
    latitude: string;
    longitude: string;
    radiusKm: number;
}) {
    return {
        nearLat: Number(point.latitude),
        nearLng: Number(point.longitude),
        radius: point.radiusKm,
        nearCleared: null,
    };
}
